import { getAdminInvoicingRunsListInfiniteQueryOptions, getNextPageParam } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";
import type { RunTypeFilter } from "./RunTypeChip";
import type { RunStatusFilter } from "./statusFilter";

const PAGE_SIZE = 100;

type QueriesInput = { search: { status?: RunStatusFilter; type?: RunTypeFilter } };

/** Status is filtered on the server and Type only on the client, so with no
 * status picked the queue fetches DRAFT runs alone. A backfill type only ever
 * travels with the BACKFILL status (a CHECK constraint on the API ties them),
 * so Type = Backfill over that default would always be an empty table. Picking
 * it therefore fetches BACKFILL runs instead; an explicit status still wins. */
const defaultStatus = (type: RunTypeFilter | undefined): RunStatusFilter =>
  type === "BACKFILL" ? "BACKFILL" : "DRAFT";

export const runsQuery = ({ search }: QueriesInput) =>
  getAdminInvoicingRunsListInfiniteQueryOptions(
    { page_size: PAGE_SIZE, status: [search.status ?? defaultStatus(search.type)] },
    { query: { getNextPageParam } },
  );

export const queries = (input: QueriesInput): Array<WarmableQuery> => [runsQuery(input)];
